module.exports = __webpack_public_path__ + "static/media/mr_ct.aea9faa8.jpg";